<template>
  <div>    
    <button type="button" class="btn btn--show-staked-bar-charts" data-toggle="modal" data-target="#exampleModal" @click="refreshStackedBar()">
       {{ buttonCollpaseDescprition }}
    </button>    
    <div class="myStackedBar" id="myP1">
      <div class="modal-body">
        <!-- <h4>
          {{ buttonCollpaseDescprition }}
        </h4> -->
        <stacked-bar-chart
              :ref="this.stackedBarRef"
              :url="url"
              :string-parameters="stringParameters"
            >
            </stacked-bar-chart>
      </div>      
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      stackedBarRef: "",
    };
  },
  mounted() {    
    this.stackedBarRef = "stacked-bar-modal" + this.refBar;
  },
  methods: {
    refreshStackedBar(){          

      if (document.getElementById("myP1").style.visibility == "visible"){
        document.getElementById("myP1").style.visibility = "hidden"; 
        document.getElementById("myP1").style.height = "0px";
      }        
      else{
        document.getElementById("myP1").style.visibility = "visible";
        document.getElementById("myP1").style.height = "400px";
      }               
    }
  },
  props: {
    refBar: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    stringParameters: {
      type: String,
      required: false,
    },
    titleGraph: {
      type: String,
      required: true,
    },
    buttonCollpaseDescprition:{
      type: String,
      required: true,
    }
  },
};
</script>
<style scoped>
.myStackedBar{
  visibility: hidden;
  height: 0px;
}
</style>